import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguageLevelsService } from 'src/app/services/languagelevels.service';
import { LanguageLevelsModalComponent } from './languageslevels-modal/languageslevels-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-languageslevels',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './languageslevels.component.html',
  styleUrls: ['./languageslevels.component.css']
})
export class LanguageLevelsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private LanguageLevelsService: LanguageLevelsService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  LanguageLevelsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getLanguageLevels();
  }

  getLanguageLevels(){
    this.LanguageLevelsService.getLanguageLevels().subscribe({
      next: (res: any) => {
        this.LanguageLevelsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar niveles de idioma:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(LanguageLevelsModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getLanguageLevels();
        }
      }
    });
  }

}
